import React from "react";
import { Breadcrumbs, Divider, Box, Link, Typography } from "@mui/material";

function BreadCrumbs({ mainCrumb, breadCrumbList, sx }) {
  return (
    <Breadcrumbs sx={{ ...sx }} separator="|" aria-label="breadcrumb">
      <Link underline="hover" color="inherit" href="/">
        <Typography
          sx={{ fontSize: "14px", lineHeight: "20px" }}
          color="#255CCE"
        >
          {`< ${mainCrumb ? mainCrumb : "Back to Listings"}`}
        </Typography>
      </Link>

      <Breadcrumbs
        sx={{
          "& .MuiBreadcrumbs-separator": {
            color: "#255CCE",
            fontSize: "14px",
            lineHeight: "20px",
          },
        }}
        separator=">"
        aria-label="breadcrumb-2"
      >
        {breadCrumbList.map((b) => {
          return (
            <Link underline="hover" color="inherit" href="/">
              <Typography
                sx={{ fontSize: "14px", lineHeight: "20px" }}
                color="#255CCE"
              >
                {b}
              </Typography>
            </Link>
          );
        })}
      </Breadcrumbs>
    </Breadcrumbs>
  );
}

export default BreadCrumbs;
